import PocketBase from "pocketbase";
import { getPredictionsApiUtils } from "./predictionsApiUtils";

class PocketBaseUtils {
    constructor(pocketBaseConfig) {
        if (pocketBaseConfig) {
            this.pb = new PocketBase(pocketBaseConfig);
            this.pb.autoCancellation(false);
        }
    }

    loginUser = async () => {
        let w = window.open();
        const oauthResponse = await this.pb.collection('users').authWithOAuth2({ provider: 'discord', scopes: ['identify'], urlCallback: (url) => { w.location.href = url } });
        const userGuilds = await getPredictionsApiUtils().getUserGuilds(oauthResponse.meta.id);
        const discordUserData = { 
            "discordId": oauthResponse.meta.id, 
            "discordAvatar": oauthResponse.meta.avatarUrl.endsWith("/.png") ? process.env.VUE_APP_DEFAULT_AVATAR_URL : oauthResponse.meta.avatarUrl,
            "discordGuilds": userGuilds,
            "preferredLeague": "5551",
        };

        const updatedUser = await this.updateUser(this.getAuthenticatedUser().id, discordUserData);
        return this.pb.authStore.isValid ? updatedUser : null;
    }

    updateUser = async (userId, userDetails) => {
        return await this.pb.collection('users').update(userId, userDetails);
    }

    logoutUser = () => {
        this.pb.authStore.clear();
    }

    refreshAuth = async () => {
        const refreshedUser = await this.pb.collection('users').authRefresh();
        const userGuilds = await getPredictionsApiUtils().getUserGuilds(refreshedUser.record.discordId);

        // Refresh a user's guild information on a session refresh
        await this.updateUser(refreshedUser.record.id, { "discordGuilds": userGuilds });
    }

    isAuthValid = () => {
        return this.pb.authStore.isValid;
    }

    getAuthenticatedUser = () => {
        return this.pb.authStore.isValid ? this.pb.authStore.model : null;
    }

    getAuthToken = () => {
        return this.pb.authStore.isValid ? this.pb.authStore.token : null;
    }
}

let _pbUtils = null;

const initPocketBaseUtils = (config) => {
    if (!_pbUtils) {
        _pbUtils = new PocketBaseUtils(config);
    }
    return _pbUtils;
}

const getPocketBaseUtils = () => {
    return _pbUtils;
}

export { initPocketBaseUtils, getPocketBaseUtils };